import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-ext";
var MaterialView = /** @class */ (function (_super) {
    tslib_1.__extends(MaterialView, _super);
    function MaterialView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.moveNextPrevented = false;
        _this.moveNextTimer = null;
        return _this;
    }
    MaterialView.prototype.moveNext = function () {
        this.moveNextPrevented = true;
        var self = this;
        this.moveNextTimer = setTimeout(function () { return self.moveNextPrevented = false; }, 3000);
    };
    Object.defineProperty(MaterialView.prototype, "materialCode", {
        get: function () {
            if (!this.$state.material && !this.$state.graphics)
                return null;
            return this.$state.material == "K" ? "K" : (this.$state.graphics || "0");
        },
        set: function (value) {
            //Material is 0, if anything else but deko is selected
            this.$state.material = value == "K" ? "K" : "0";
            //Set graphics if material is anything but deko
            this.$state.graphics = value != "K" ? value : null;
        },
        enumerable: true,
        configurable: true
    });
    MaterialView = tslib_1.__decorate([
        Component
    ], MaterialView);
    return MaterialView;
}(Vue));
export default MaterialView;
